import { useEffect, useRef } from "react";

export const Hero = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    videoRef.current?.play().catch(() => {});
  }, []);

  return (
  <section data-testid="hero-section" id="top" className="relative jpd-grain overflow-hidden min-h-screen flex items-end">
    <div className="absolute inset-0">
      <img src="/hero-poster.jpg" alt="Brad's Mobile Detailing — showroom shine" className="w-full h-full object-cover" />
      <video
        ref={videoRef}
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        poster="/hero-poster.jpg"
        aria-hidden="true"
        onEnded={() => { const v = videoRef.current; if (v) { v.currentTime = 0; v.play().catch(() => {}); } }}
      >
        <source src="/hero-video.mp4" type="video/mp4" />
        <source src="/hero-video.webm" type="video/webm" />
      </video>
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C] via-[#0A0A0C]/45 to-[#0A0A0C]/55" />
    </div>

    <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 w-full pb-16 md:pb-20 pt-48">
      <p data-testid="hero-eyebrow" className="jpd-fade-up font-display uppercase text-sm md:text-base font-medium tracking-[0.18em] text-white">
        #1 Best Mobile Detailing Services
      </p>
      <h1
        data-testid="hero-headline"
        className="jpd-fade-up mt-4 font-display uppercase font-semibold leading-[1.05] tracking-wide text-white text-4xl sm:text-5xl lg:text-6xl xl:text-7xl"
        style={{ animationDelay: "100ms" }}
      >
        Brad's Mobile Detailing
      </h1>
    </div>
  </section>
  );
};
